import React from "react";
import Link from "next/link";
import { Col, Row } from "react-bootstrap";
import { CustomInput, InputLayout, SubmitButton } from "../components/shared/input";
import FormSubmit from "../components/shared/submit";
import dynamic from "next/dynamic";

const Authentication = dynamic(() => import("../components/Layouts/Authentication"));

const Forgot = () => {
	return (
		<Authentication title="Forgot - Mescadesigners">
			<FormSubmit url="/forgot" next="/signin">
				<h1 className=" fs-4 fw-bold text-center">Forgot Password</h1>
				<p className="text-center mb-4 font-e-lg">No Worries We Got You Back</p>
				<InputLayout className="overflow-hidden">
					<CustomInput name="email" title="Email Or Username" placeholder="UserName Or Email" indicator={true} />
				</InputLayout>
				<Row className="justify-content-between mt-3 px-2">
					<Col sm="auto">
						<Link href="/signup">
							<a href="/signup" className="font-md text-info fw-bold"></a>
						</Link>
					</Col>
					<Col sm="auto">
						<Link href="/signin">
							<a href="/signin" className="font-md text-primary fw-bold">
								Signin
							</a>
						</Link>
					</Col>
				</Row>
				<SubmitButton title="Reset" variant="dark rounded-8 my-4 py-2" />
			</FormSubmit>
		</Authentication>
	);
};

export default Forgot;
